import { SortBy } from "shared/types";

export const CLAIMS_TAB_KEY = "claims";

export const CLAIMS_PAGE_KEY = "clAnClaimState";
export const CLAIM_ID_QUERY_KEY = "claimId";
export const CLAIM_LABEL_QUERY_KEY = "claimExternalId";
export const VEHICLES_PAGE_KEY = "clAnVehicleState";

export const CLAIMS_TABLE_PAGE_KEY = "clAn-claimsTable";
export const CLAIMS_TABLE_DEFAULT_SORT: SortBy = { date: "desc" };
